import { enUS, sv, nb, da, fi, de, nl, pl, type Locale } from 'date-fns/locale';
import { LocaleLanguage } from 'models/locale-format';

export const LocaleMap: Record<LocaleLanguage, Locale> = {
    [LocaleLanguage.EN_US]: enUS,
    [LocaleLanguage.SV_SE]: sv,
    [LocaleLanguage.NO_NO]: nb,
    [LocaleLanguage.DA_DK]: da,
    [LocaleLanguage.FI_FI]: fi,
    [LocaleLanguage.DE_DE]: de,
    [LocaleLanguage.NL_NL]: nl,
    [LocaleLanguage.PL_PL]: pl,
    [LocaleLanguage.DEBUG]: enUS,
};
